import { Controller } from '@hotwired/stimulus';

const MAX_DEFAULT = 5;

// Manages the Hub Emails list on the Nova valuer details edit form.
// Saved rows (rendered server-side) and newly added rows share the same
// structure, so add/remove/renumbering all operate on the `row` targets uniformly.
export default class extends Controller {
  static targets = ['rows', 'row', 'template', 'addButtonWrapper'];
  static values = { max: { type: Number, default: MAX_DEFAULT } };

  connect() {
    this._onInput = () => this.flagDuplicates();
    this.element.addEventListener('input', this._onInput);
    this.refresh();
    this.flagDuplicates();
  }

  disconnect() {
    this.element.removeEventListener('input', this._onInput);
  }

  add() {
    if (this.rowTargets.length >= this.maxValue) return;

    this.rowsTarget.appendChild(this.templateTarget.content.cloneNode(true));
    this.refresh();
    this.flagDuplicates();
  }

  remove(event) {
    const row = event.target.closest('[data-valuer-hub-emails-target="row"]');
    if (!row) return;

    row.remove();
    this.refresh();
    this.flagDuplicates();
  }

  // Marks repeated email values invalid so the native `invalid` event (handled by
  // the input controller) blocks submission and shows the message; cleared on edit.
  flagDuplicates() {
    const inputs = Array.from(this.element.querySelectorAll('input[type="email"]'));
    const counts = {};
    inputs.forEach((input) => {
      const value = input.value.trim().toLowerCase();
      if (value) counts[value] = (counts[value] || 0) + 1;
    });

    inputs.forEach((input) => {
      const value = input.value.trim().toLowerCase();
      input.setCustomValidity(value && counts[value] > 1 ? 'Email must be unique' : '');
    });
  }

  refresh() {
    this.rowTargets.forEach((row, index) => {
      const number = row.querySelector('[data-hub-email-number]');
      if (number) number.textContent = `${index + 1}.`;

      const deleteButton = row.querySelector('[data-hub-email-delete]');
      if (deleteButton) deleteButton.classList.toggle('hidden', index === 0);
    });

    this.addButtonWrapperTarget.classList.toggle('hidden', this.rowTargets.length >= this.maxValue);
  }
}
